import { render, staticRenderFns } from "./DataTiWen.vue?vue&type=template&id=6e1a2e40&"
import script from "./DataTiWen.vue?vue&type=script&lang=js&"
export * from "./DataTiWen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports